import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_token'
const LoginName = 'vue_admin_loginName'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLoginName() {
  return Cookies.get(LoginName)
}

export function setLoginName(loginName) {
  return Cookies.set(LoginName, loginName)
}
